import { render, staticRenderFns } from "./TypeDetail.vue?vue&type=template&id=c2881b42&scoped=true&"
import script from "./TypeDetail.vue?vue&type=script&lang=js&"
export * from "./TypeDetail.vue?vue&type=script&lang=js&"
import style0 from "./TypeDetail.vue?vue&type=style&index=0&id=c2881b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2881b42",
  null
  
)

export default component.exports